(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["flight-fuel-aging-cause"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-ffcause-section]';

    const initialize = (section) => {
      if (section.dataset.ffcauseReady === 'true') return;
      section.dataset.ffcauseReady = 'true';

      if (!('IntersectionObserver' in window)) {
        section.classList.add('is-visible');
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            section.classList.add('is-visible');
            observer.disconnect();
          });
        },
        {
          threshold: 0.14,
          rootMargin: '0px 0px -8% 0px'
        }
      );

      observer.observe(section);
    };

    document.querySelectorAll(selector).forEach(initialize);

    document.addEventListener('shopify:section:load', (event) => {
      if (event.target.matches(selector)) {
        initialize(event.target);
      } else {
        event.target.querySelectorAll(selector).forEach(initialize);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flight-fuel-aging-hands"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-ffah-hero]';

    const initializeTopReset = (hero) => {
      if (!hero || hero.dataset.ffahTopResetReady === 'true') return;
      hero.dataset.ffahTopResetReady = 'true';

      let inPageAnchorActivated = false;

      const markInPageAnchor = (event) => {
        const link = event.target.closest('a[href^="#"]');
        if (!link) return;

        inPageAnchorActivated = true;

        if (!link.hasAttribute('data-ffah-smooth-scroll')) return;

        const targetId = link.getAttribute('href').slice(1);
        const target = document.getElementById(targetId);
        if (!target) return;

        event.preventDefault();

        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        target.scrollIntoView({
          behavior: reduceMotion ? 'auto' : 'smooth',
          block: 'start'
        });
      };

      const resetToTop = () => {
        if (inPageAnchorActivated) return;

        if (window.location.hash) {
          window.history.replaceState(
            window.history.state,
            '',
            `${window.location.pathname}${window.location.search}`
          );
        }

        window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
      };

      if ('scrollRestoration' in window.history) {
        window.history.scrollRestoration = 'manual';
      }

      document.addEventListener('click', markInPageAnchor, { capture: true });
      resetToTop();
      requestAnimationFrame(() => requestAnimationFrame(resetToTop));
      window.addEventListener('load', resetToTop, { once: true });
      window.addEventListener('pageshow', (event) => {
        if (event.persisted) resetToTop();
      });
    };

    document.querySelectorAll(selector).forEach(initializeTopReset);

    document.addEventListener('shopify:section:load', (event) => {
      if (event.target.matches(selector)) {
        initializeTopReset(event.target);
      } else {
        event.target.querySelectorAll(selector).forEach(initializeTopReset);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flight-fuel-aging-insights"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-ffreframe-section]';

    const initialize = (section) => {
      if (section.dataset.ffreframeReady === 'true') return;
      section.dataset.ffreframeReady = 'true';

      if (!('IntersectionObserver' in window)) {
        section.classList.add('is-visible');
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            section.classList.add('is-visible');
            observer.disconnect();
          });
        },
        {
          threshold: 0.16,
          rootMargin: '0px 0px -8% 0px'
        }
      );

      observer.observe(section);
    };

    document.querySelectorAll(selector).forEach(initialize);

    document.addEventListener('shopify:section:load', (event) => {
      if (event.target.matches(selector)) {
        initialize(event.target);
      } else {
        event.target.querySelectorAll(selector).forEach(initialize);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flight-fuel-aging-quiz"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initQuiz = (root) => {
      if (!root || root.dataset.ffqReady === 'true') return;
      root.dataset.ffqReady = 'true';

      const params = new URL(window.location.href).searchParams;
      const triggerParameter = root.dataset.triggerParameter || 'quiz';
      const triggerValue = root.dataset.triggerValue || 'aging-hands';
      const previewMode = params.get('quiz_preview') === '1';
      const resetMode = params.get('quiz_reset') === '1';
      const storageKey = root.dataset.storageKey || 'dartsrx-aging-quiz';
      const shouldTrigger = params.get(triggerParameter) === triggerValue;
      const dialog = root.querySelector('[role="dialog"]');
      const intro = root.querySelector('[data-ffq-intro]');
      const questions = Array.from(root.querySelectorAll('[data-ffq-question]'));
      const checkpoint = root.querySelector('[data-ffq-checkpoint]');
      const result = root.querySelector('[data-ffq-result]');
      const recommendation = root.querySelector('[data-ffq-recommendation]');
      const discount = root.querySelector('[data-ffq-discount]');
      const progressWrap = root.querySelector('[data-ffq-progress-wrap]');
      const progressBar = root.querySelector('[data-ffq-progress-bar]');
      const progressValue = root.querySelector('[data-ffq-progress-value]');
      const stepLabel = root.querySelector('[data-ffq-step-label]');
      const backButton = root.querySelector('[data-ffq-back]');
      const resultTitle = root.querySelector('[data-ffq-result-title]');
      const resultExplanation = root.querySelector('[data-ffq-result-explanation]');
      const checkpointAfter = Math.min(
        Math.max(Number(root.dataset.checkpointAfter || 3), 1),
        Math.max(questions.length - 1, 1)
      );
      let currentQuestion = 0;
      let checkpointSeen = false;
      let previousFocus = null;
      let closeTimer = null;
      const answers = [];

      const storage = {
        get() {
          try {
            return window.sessionStorage.getItem(storageKey);
          } catch (error) {
            return null;
          }
        },
        set(value) {
          try {
            window.sessionStorage.setItem(storageKey, value);
          } catch (error) {
            return;
          }
        },
        remove() {
          try {
            window.sessionStorage.removeItem(storageKey);
          } catch (error) {
            return;
          }
        }
      };

      const track = (eventName) => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: eventName });
        if (typeof window.fbq === 'function') {
          window.fbq('trackCustom', eventName);
        }
      };

      const updateProgress = (percent, label) => {
        const safePercent = Math.max(0, Math.min(percent, 100));
        progressBar.style.width = `${safePercent}%`;
        progressValue.textContent = `${safePercent}%`;
        if (label) stepLabel.textContent = label;
      };

      const setActiveStage = (stage) => {
        root.querySelectorAll('.ffq__stage').forEach((item) => {
          item.classList.remove('is-active');
          item.hidden = true;
        });
        stage.hidden = false;
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            stage.classList.add('is-active');
            const focusTarget = stage.querySelector('button:not([hidden])');
            if (focusTarget) focusTarget.focus({ preventScroll: true });
          });
        });
      };

      const showIntro = () => {
        progressWrap.hidden = true;
        backButton.hidden = true;
        setActiveStage(intro);
      };

      const showQuestion = (index) => {
        currentQuestion = Math.max(0, Math.min(index, questions.length - 1));
        progressWrap.hidden = false;
        backButton.hidden = false;
        const percent = Math.round(((currentQuestion + 1) / (questions.length + 1)) * 100);
        updateProgress(percent, `Question ${currentQuestion + 1} of ${questions.length}`);
        setActiveStage(questions[currentQuestion]);
      };

      const showCheckpoint = () => {
        checkpointSeen = true;
        progressWrap.hidden = false;
        backButton.hidden = false;
        updateProgress(50, 'What your answers show');
        setActiveStage(checkpoint);
      };

      const getResult = () => {
        const totals = {
          steady: 0,
          focus: 0,
          control: 0,
          confidence: 0
        };
        answers.forEach((answer) => {
          if (!answer || answer.category === 'none') return;
          if (Object.prototype.hasOwnProperty.call(totals, answer.category)) {
            totals[answer.category] += answer.score;
          }
        });

        const category = Object.keys(totals).reduce((best, item) => {
          return totals[item] > totals[best] ? item : best;
        }, 'steady');
        return { category };
      };

      const showResult = () => {
        const outcome = getResult();
        const titleAttribute = `${outcome.category}Title`;
        const explanationAttribute = `${outcome.category}Explanation`;
        resultTitle.textContent = result.dataset[titleAttribute] || resultTitle.textContent;
        resultExplanation.textContent = result.dataset[explanationAttribute] || resultExplanation.textContent;
        progressWrap.hidden = false;
        backButton.hidden = false;
        updateProgress(100, root.dataset.progressLabel || 'Your throw check');
        setActiveStage(result);
        track('FlightFuelQuizComplete');
      };

      const showRecommendation = () => {
        progressWrap.hidden = false;
        backButton.hidden = false;
        updateProgress(100, root.dataset.recommendationProgressLabel || 'Your recommendation');
        setActiveStage(recommendation);
        track('FlightFuelQuizRecommendationView');
      };

      const showDiscount = () => {
        progressWrap.hidden = false;
        backButton.hidden = false;
        updateProgress(100, root.dataset.discountProgressLabel || 'Your discount');
        setActiveStage(discount);
        track('FlightFuelQuizDiscountView');
      };

      const openQuiz = () => {
        previousFocus = document.activeElement;
        root.hidden = false;
        root.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('ffq-lock');
        document.body.classList.add('ffq-lock');
        window.requestAnimationFrame(() => {
          root.classList.add('is-open');
          const startButton = root.querySelector('[data-ffq-start]');
          if (startButton) startButton.focus({ preventScroll: true });
        });
        track('FlightFuelQuizOpen');
      };

      const closeQuiz = (remember = true) => {
        if (closeTimer) window.clearTimeout(closeTimer);
        root.classList.remove('is-open');
        root.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('ffq-lock');
        document.body.classList.remove('ffq-lock');
        if (remember) storage.set('dismissed');
        closeTimer = window.setTimeout(() => {
          root.hidden = true;
        }, 270);
        if (previousFocus && typeof previousFocus.focus === 'function') {
          previousFocus.focus({ preventScroll: true });
        }
      };

      const closeAndScroll = (selector, eventName) => {
        closeQuiz(true);
        track(eventName);
        window.setTimeout(() => {
          const target = document.querySelector(selector);
          if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 300);
      };

      root.querySelectorAll('[data-ffq-close]').forEach((button) => {
        button.addEventListener('click', () => closeQuiz(true));
      });

      root.querySelector('[data-ffq-start]')?.addEventListener('click', () => {
        track('FlightFuelQuizStart');
        showQuestion(0);
      });

      questions.forEach((question, index) => {
        question.querySelectorAll('[data-ffq-answer]').forEach((button) => {
          button.addEventListener('click', () => {
            question.querySelectorAll('[data-ffq-answer]').forEach((answer) => {
              answer.classList.remove('is-selected');
            });
            button.classList.add('is-selected');
            answers[index] = {
              category: question.dataset.category || 'none',
              score: Number(button.dataset.score || 0)
            };
            track('FlightFuelQuizStep');

            window.setTimeout(() => {
              const nextQuestion = index + 1;
              if (!checkpointSeen && nextQuestion === checkpointAfter) {
                currentQuestion = nextQuestion;
                showCheckpoint();
                return;
              }
              if (nextQuestion < questions.length) {
                showQuestion(nextQuestion);
                return;
              }
              showResult();
            }, 230);
          });
        });
      });

      root.querySelector('[data-ffq-continue]')?.addEventListener('click', () => {
        showQuestion(currentQuestion);
      });

      backButton.addEventListener('click', () => {
        if (!discount.hidden) {
          showRecommendation();
          return;
        }
        if (!recommendation.hidden) {
          showResult();
          return;
        }
        if (!result.hidden) {
          showQuestion(questions.length - 1);
          return;
        }
        if (!checkpoint.hidden) {
          showQuestion(Math.max(checkpointAfter - 1, 0));
          return;
        }
        if (currentQuestion > 0) {
          showQuestion(currentQuestion - 1);
          return;
        }
        showIntro();
      });

      root.querySelector('[data-ffq-see-recommendation]')?.addEventListener('click', () => {
        showRecommendation();
      });

      root.querySelector('[data-ffq-result-cta]')?.addEventListener('click', () => {
        showDiscount();
      });

      root.querySelector('[data-ffq-buy]')?.addEventListener('click', () => {
        closeAndScroll(root.dataset.scrollTarget || '#aging-buy', 'FlightFuelQuizBuyBoxClick');
      });

      root.querySelector('[data-ffq-secondary-cta]')?.addEventListener('click', () => {
        closeAndScroll(root.dataset.secondaryTarget || '#aging-reasons', 'FlightFuelQuizLearnClick');
      });

      root.querySelector('[data-ffq-recommendation-back]')?.addEventListener('click', () => {
        showResult();
      });

      root.querySelector('[data-ffq-discount-back]')?.addEventListener('click', () => {
        showRecommendation();
      });

      root.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          closeQuiz(true);
          return;
        }
        if (event.key !== 'Tab') return;
        const focusable = Array.from(
          dialog.querySelectorAll('button:not([hidden]):not([disabled]), a[href], [tabindex]:not([tabindex="-1"])')
        ).filter((element) => element.offsetParent !== null);
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });

      if (resetMode) storage.remove();
      showIntro();

      if (shouldTrigger && (previewMode || storage.get() !== 'dismissed')) {
        window.setTimeout(openQuiz, Number(root.dataset.delay || 500));
      }
    };

    const initAllQuizzes = (scope = document) => {
      scope.querySelectorAll('[data-ffq]').forEach(initQuiz);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAllQuizzes());
    } else {
      initAllQuizzes();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initAllQuizzes(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flight-fuel-aging-tried"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-fftried-section]';

    const initialize = (section) => {
      if (section.dataset.fftriedReady === 'true') return;
      section.dataset.fftriedReady = 'true';

      if (!('IntersectionObserver' in window)) {
        section.classList.add('is-visible');
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            section.classList.add('is-visible');
            observer.disconnect();
          });
        },
        {
          threshold: 0.12,
          rootMargin: '0px 0px -8% 0px'
        }
      );

      observer.observe(section);
    };

    document.querySelectorAll(selector).forEach(initialize);

    document.addEventListener('shopify:section:load', (event) => {
      if (event.target.matches(selector)) {
        initialize(event.target);
      } else {
        event.target.querySelectorAll(selector).forEach(initialize);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flight-fuel-alcohol-quiz"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const resetDirectEntryScroll = () => {
      const isBuyBoxEntry = window.location.hash === '#alcohol-buy';
      if (window.location.hash && !isBuyBoxEntry) return;
      if (isBuyBoxEntry) {
        window.history.replaceState(
          window.history.state,
          document.title,
          `${window.location.pathname}${window.location.search}`
        );
      }
      if ('scrollRestoration' in window.history) {
        window.history.scrollRestoration = 'manual';
      }
      const scrollToHero = () => window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
      scrollToHero();
      window.requestAnimationFrame(scrollToHero);
      window.setTimeout(scrollToHero, 80);
      window.setTimeout(scrollToHero, 300);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', resetDirectEntryScroll, { once: true });
    } else {
      resetDirectEntryScroll();
    }
    window.addEventListener('pageshow', resetDirectEntryScroll);

    const initQuiz = (root) => {
      if (!root || root.dataset.ffqReady === 'true') return;
      root.dataset.ffqReady = 'true';

      const params = new URL(window.location.href).searchParams;
      const triggerParameter = root.dataset.triggerParameter || 'quiz';
      const triggerValue = root.dataset.triggerValue || 'alcohol';
      const previewMode = params.get('quiz_preview') === '1';
      const resetMode = params.get('quiz_reset') === '1';
      const storageKey = root.dataset.storageKey || 'dartsrx-alcohol-quiz';
      const shouldTrigger = params.get(triggerParameter) === triggerValue;
      const dialog = root.querySelector('[role="dialog"]');
      const intro = root.querySelector('[data-ffq-intro]');
      const questions = Array.from(root.querySelectorAll('[data-ffq-question]'));
      const checkpoint = root.querySelector('[data-ffq-checkpoint]');
      const result = root.querySelector('[data-ffq-result]');
      const recommendation = root.querySelector('[data-ffq-recommendation]');
      const discount = root.querySelector('[data-ffq-discount]');
      const progressWrap = root.querySelector('[data-ffq-progress-wrap]');
      const progressBar = root.querySelector('[data-ffq-progress-bar]');
      const progressValue = root.querySelector('[data-ffq-progress-value]');
      const stepLabel = root.querySelector('[data-ffq-step-label]');
      const backButton = root.querySelector('[data-ffq-back]');
      const resultTitle = root.querySelector('[data-ffq-result-title]');
      const resultExplanation = root.querySelector('[data-ffq-result-explanation]');
      const checkpointAfter = Math.min(
        Math.max(Number(root.dataset.checkpointAfter || 3), 1),
        Math.max(questions.length - 1, 1)
      );
      let currentQuestion = 0;
      let checkpointSeen = false;
      let previousFocus = null;
      let closeTimer = null;
      const answers = [];

      const storage = {
        get() {
          try {
            return window.sessionStorage.getItem(storageKey);
          } catch (error) {
            return null;
          }
        },
        set(value) {
          try {
            window.sessionStorage.setItem(storageKey, value);
          } catch (error) {
            return;
          }
        },
        remove() {
          try {
            window.sessionStorage.removeItem(storageKey);
          } catch (error) {
            return;
          }
        }
      };

      const track = (eventName) => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: eventName });
        if (typeof window.fbq === 'function') {
          window.fbq('trackCustom', eventName);
        }
      };

      const updateProgress = (percent, label) => {
        const safePercent = Math.max(0, Math.min(percent, 100));
        progressBar.style.width = `${safePercent}%`;
        progressValue.textContent = `${safePercent}%`;
        if (label) stepLabel.textContent = label;
      };

      const setActiveStage = (stage) => {
        root.classList.toggle(
          'is-result-visual',
          stage === recommendation || stage === discount
        );
        root.classList.remove(
          'is-stage-intro',
          'is-stage-question',
          'is-stage-checkpoint',
          'is-stage-result',
          'is-stage-recommendation',
          'is-stage-discount'
        );
        if (stage === intro) root.classList.add('is-stage-intro');
        else if (questions.includes(stage)) root.classList.add('is-stage-question');
        else if (stage === checkpoint) root.classList.add('is-stage-checkpoint');
        else if (stage === result) root.classList.add('is-stage-result');
        else if (stage === recommendation) root.classList.add('is-stage-recommendation');
        else if (stage === discount) root.classList.add('is-stage-discount');
        root.querySelectorAll('.ffq__stage').forEach((item) => {
          item.classList.remove('is-active');
          item.hidden = true;
        });
        stage.hidden = false;
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            stage.classList.add('is-active');
            const focusTarget = stage.querySelector('button:not([hidden])');
            if (focusTarget) focusTarget.focus({ preventScroll: true });
          });
        });
      };

      const showIntro = () => {
        progressWrap.hidden = true;
        backButton.hidden = true;
        setActiveStage(intro);
      };

      const showQuestion = (index) => {
        currentQuestion = Math.max(0, Math.min(index, questions.length - 1));
        progressWrap.hidden = false;
        backButton.hidden = false;
        const percent = Math.round(((currentQuestion + 1) / (questions.length + 1)) * 100);
        updateProgress(percent, `Question ${currentQuestion + 1} of ${questions.length}`);
        setActiveStage(questions[currentQuestion]);
      };

      const showCheckpoint = () => {
        checkpointSeen = true;
        progressWrap.hidden = false;
        backButton.hidden = false;
        updateProgress(50, 'What your answers show');
        setActiveStage(checkpoint);
      };

      const getResult = () => {
        const totals = {
          steady: 0,
          focus: 0,
          control: 0,
          confidence: 0
        };
        answers.forEach((answer) => {
          if (!answer || answer.category === 'none') return;
          if (Object.prototype.hasOwnProperty.call(totals, answer.category)) {
            totals[answer.category] += answer.score;
          }
        });

        const category = Object.keys(totals).reduce((best, item) => {
          return totals[item] > totals[best] ? item : best;
        }, 'steady');
        return { category };
      };

      const showResult = () => {
        const outcome = getResult();
        const titleAttribute = `${outcome.category}Title`;
        const explanationAttribute = `${outcome.category}Explanation`;
        resultTitle.textContent = result.dataset[titleAttribute] || resultTitle.textContent;
        resultExplanation.textContent = result.dataset[explanationAttribute] || resultExplanation.textContent;
        progressWrap.hidden = false;
        backButton.hidden = false;
        updateProgress(100, root.dataset.progressLabel || 'Your throw check');
        setActiveStage(result);
        track('FlightFuelQuizComplete');
      };

      const showRecommendation = () => {
        progressWrap.hidden = false;
        backButton.hidden = false;
        updateProgress(100, root.dataset.recommendationProgressLabel || 'Your recommendation');
        setActiveStage(recommendation);
        track('FlightFuelQuizRecommendationView');
      };

      const showDiscount = () => {
        progressWrap.hidden = false;
        backButton.hidden = false;
        updateProgress(100, root.dataset.discountProgressLabel || 'Your discount');
        setActiveStage(discount);
        track('FlightFuelQuizDiscountView');
      };

      const openQuiz = () => {
        previousFocus = document.activeElement;
        root.hidden = false;
        root.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('ffq-lock');
        document.body.classList.add('ffq-lock');
        window.requestAnimationFrame(() => {
          root.classList.add('is-open');
          const startButton = root.querySelector('[data-ffq-start]');
          if (startButton) startButton.focus({ preventScroll: true });
        });
        track('FlightFuelQuizOpen');
      };

      const closeQuiz = (remember = true) => {
        if (closeTimer) window.clearTimeout(closeTimer);
        root.classList.remove('is-open');
        root.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('ffq-lock');
        document.body.classList.remove('ffq-lock');
        if (remember) storage.set('dismissed');
        closeTimer = window.setTimeout(() => {
          root.hidden = true;
        }, 270);
        if (previousFocus && typeof previousFocus.focus === 'function') {
          previousFocus.focus({ preventScroll: true });
        }
      };

      const closeAndScroll = (selector, eventName) => {
        closeQuiz(true);
        track(eventName);
        window.setTimeout(() => {
          const target = document.querySelector(selector);
          if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 300);
      };

      root.querySelectorAll('[data-ffq-close]').forEach((button) => {
        button.addEventListener('click', () => closeQuiz(true));
      });

      root.querySelector('[data-ffq-start]')?.addEventListener('click', () => {
        track('FlightFuelQuizStart');
        showQuestion(0);
      });

      questions.forEach((question, index) => {
        question.querySelectorAll('[data-ffq-answer]').forEach((button) => {
          button.addEventListener('click', () => {
            question.querySelectorAll('[data-ffq-answer]').forEach((answer) => {
              answer.classList.remove('is-selected');
            });
            button.classList.add('is-selected');
            answers[index] = {
              category: question.dataset.category || 'none',
              score: Number(button.dataset.score || 0)
            };
            track('FlightFuelQuizStep');

            window.setTimeout(() => {
              const nextQuestion = index + 1;
              if (!checkpointSeen && nextQuestion === checkpointAfter) {
                currentQuestion = nextQuestion;
                showCheckpoint();
                return;
              }
              if (nextQuestion < questions.length) {
                showQuestion(nextQuestion);
                return;
              }
              showResult();
            }, 230);
          });
        });
      });

      root.querySelector('[data-ffq-continue]')?.addEventListener('click', () => {
        showQuestion(currentQuestion);
      });

      backButton.addEventListener('click', () => {
        if (!discount.hidden) {
          showRecommendation();
          return;
        }
        if (!recommendation.hidden) {
          showResult();
          return;
        }
        if (!result.hidden) {
          showQuestion(questions.length - 1);
          return;
        }
        if (!checkpoint.hidden) {
          showQuestion(Math.max(checkpointAfter - 1, 0));
          return;
        }
        if (currentQuestion > 0) {
          showQuestion(currentQuestion - 1);
          return;
        }
        showIntro();
      });

      root.querySelector('[data-ffq-see-recommendation]')?.addEventListener('click', () => {
        showRecommendation();
      });

      root.querySelector('[data-ffq-result-cta]')?.addEventListener('click', () => {
        showDiscount();
      });

      root.querySelector('[data-ffq-buy]')?.addEventListener('click', () => {
        closeAndScroll(root.dataset.scrollTarget || '#alcohol-buy', 'FlightFuelQuizBuyBoxClick');
      });

      root.querySelector('[data-ffq-secondary-cta]')?.addEventListener('click', () => {
        closeAndScroll(root.dataset.secondaryTarget || '#what-dartitis-feels-like', 'FlightFuelQuizLearnClick');
      });

      root.querySelector('[data-ffq-recommendation-back]')?.addEventListener('click', () => {
        showResult();
      });

      root.querySelector('[data-ffq-discount-back]')?.addEventListener('click', () => {
        showRecommendation();
      });

      root.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          closeQuiz(true);
          return;
        }
        if (event.key !== 'Tab') return;
        const focusable = Array.from(
          dialog.querySelectorAll('button:not([hidden]):not([disabled]), a[href], [tabindex]:not([tabindex="-1"])')
        ).filter((element) => element.offsetParent !== null);
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });

      if (resetMode) storage.remove();
      showIntro();

      if (shouldTrigger && (previewMode || storage.get() !== 'dismissed')) {
        window.setTimeout(openQuiz, Number(root.dataset.delay || 500));
      }
    };

    const initAllQuizzes = (scope = document) => {
      scope.querySelectorAll('[data-ffq]').forEach(initQuiz);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAllQuizzes());
    } else {
      initAllQuizzes();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initAllQuizzes(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flight-fuel-dartitis-quiz"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initQuiz = (root) => {
      if (!root || root.dataset.ffqReady === 'true') return;
      root.dataset.ffqReady = 'true';

      const params = new URL(window.location.href).searchParams;
      const triggerParameter = root.dataset.triggerParameter || 'quiz';
      const triggerValue = root.dataset.triggerValue || 'dartitis';
      const previewMode = params.get('quiz_preview') === '1';
      const resetMode = params.get('quiz_reset') === '1';
      const storageKey = root.dataset.storageKey || 'dartsrx-dartitis-quiz';
      const shouldTrigger = params.get(triggerParameter) === triggerValue;
      const dialog = root.querySelector('[role="dialog"]');
      const intro = root.querySelector('[data-ffq-intro]');
      const questions = Array.from(root.querySelectorAll('[data-ffq-question]'));
      const checkpoint = root.querySelector('[data-ffq-checkpoint]');
      const result = root.querySelector('[data-ffq-result]');
      const recommendation = root.querySelector('[data-ffq-recommendation]');
      const discount = root.querySelector('[data-ffq-discount]');
      const progressWrap = root.querySelector('[data-ffq-progress-wrap]');
      const progressBar = root.querySelector('[data-ffq-progress-bar]');
      const progressValue = root.querySelector('[data-ffq-progress-value]');
      const stepLabel = root.querySelector('[data-ffq-step-label]');
      const backButton = root.querySelector('[data-ffq-back]');
      const resultTitle = root.querySelector('[data-ffq-result-title]');
      const resultExplanation = root.querySelector('[data-ffq-result-explanation]');
      const checkpointAfter = Math.min(
        Math.max(Number(root.dataset.checkpointAfter || 3), 1),
        Math.max(questions.length - 1, 1)
      );
      let currentQuestion = 0;
      let checkpointSeen = false;
      let previousFocus = null;
      let closeTimer = null;
      const answers = [];

      const storage = {
        get() {
          try {
            return window.sessionStorage.getItem(storageKey);
          } catch (error) {
            return null;
          }
        },
        set(value) {
          try {
            window.sessionStorage.setItem(storageKey, value);
          } catch (error) {
            return;
          }
        },
        remove() {
          try {
            window.sessionStorage.removeItem(storageKey);
          } catch (error) {
            return;
          }
        }
      };

      const track = (eventName) => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: eventName });
        if (typeof window.fbq === 'function') {
          window.fbq('trackCustom', eventName);
        }
      };

      const updateProgress = (percent, label) => {
        const safePercent = Math.max(0, Math.min(percent, 100));
        progressBar.style.width = `${safePercent}%`;
        progressValue.textContent = `${safePercent}%`;
        if (label) stepLabel.textContent = label;
      };

      const setActiveStage = (stage) => {
        root.querySelectorAll('.ffq__stage').forEach((item) => {
          item.classList.remove('is-active');
          item.hidden = true;
        });
        stage.hidden = false;
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            stage.classList.add('is-active');
            const focusTarget = stage.querySelector('button:not([hidden])');
            if (focusTarget) focusTarget.focus({ preventScroll: true });
          });
        });
      };

      const showIntro = () => {
        progressWrap.hidden = true;
        backButton.hidden = true;
        setActiveStage(intro);
      };

      const showQuestion = (index) => {
        currentQuestion = Math.max(0, Math.min(index, questions.length - 1));
        progressWrap.hidden = false;
        backButton.hidden = false;
        const percent = Math.round(((currentQuestion + 1) / (questions.length + 1)) * 100);
        updateProgress(percent, `Question ${currentQuestion + 1} of ${questions.length}`);
        setActiveStage(questions[currentQuestion]);
      };

      const showCheckpoint = () => {
        checkpointSeen = true;
        progressWrap.hidden = false;
        backButton.hidden = false;
        updateProgress(50, 'What your answers show');
        setActiveStage(checkpoint);
      };

      const getResult = () => {
        const totals = {
          steady: 0,
          focus: 0,
          control: 0,
          confidence: 0
        };
        answers.forEach((answer) => {
          if (!answer || answer.category === 'none') return;
          if (Object.prototype.hasOwnProperty.call(totals, answer.category)) {
            totals[answer.category] += answer.score;
          }
        });

        const category = Object.keys(totals).reduce((best, item) => {
          return totals[item] > totals[best] ? item : best;
        }, 'steady');
        return { category };
      };

      const showResult = () => {
        const outcome = getResult();
        const titleAttribute = `${outcome.category}Title`;
        const explanationAttribute = `${outcome.category}Explanation`;
        resultTitle.textContent = result.dataset[titleAttribute] || resultTitle.textContent;
        resultExplanation.textContent = result.dataset[explanationAttribute] || resultExplanation.textContent;
        progressWrap.hidden = false;
        backButton.hidden = false;
        updateProgress(100, root.dataset.progressLabel || 'Your throw check');
        setActiveStage(result);
        track('FlightFuelQuizComplete');
      };

      const showRecommendation = () => {
        progressWrap.hidden = false;
        backButton.hidden = false;
        updateProgress(100, root.dataset.recommendationProgressLabel || 'Your recommendation');
        setActiveStage(recommendation);
        track('FlightFuelQuizRecommendationView');
      };

      const showDiscount = () => {
        progressWrap.hidden = false;
        backButton.hidden = false;
        updateProgress(100, root.dataset.discountProgressLabel || 'Your discount');
        setActiveStage(discount);
        track('FlightFuelQuizDiscountView');
      };

      const openQuiz = () => {
        previousFocus = document.activeElement;
        root.hidden = false;
        root.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('ffq-lock');
        document.body.classList.add('ffq-lock');
        window.requestAnimationFrame(() => {
          root.classList.add('is-open');
          const startButton = root.querySelector('[data-ffq-start]');
          if (startButton) startButton.focus({ preventScroll: true });
        });
        track('FlightFuelQuizOpen');
      };

      const closeQuiz = (remember = true) => {
        if (closeTimer) window.clearTimeout(closeTimer);
        root.classList.remove('is-open');
        root.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('ffq-lock');
        document.body.classList.remove('ffq-lock');
        if (remember) storage.set('dismissed');
        closeTimer = window.setTimeout(() => {
          root.hidden = true;
        }, 270);
        if (previousFocus && typeof previousFocus.focus === 'function') {
          previousFocus.focus({ preventScroll: true });
        }
      };

      const closeAndScroll = (selector, eventName) => {
        closeQuiz(true);
        track(eventName);
        window.setTimeout(() => {
          const target = document.querySelector(selector);
          if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 300);
      };

      root.querySelectorAll('[data-ffq-close]').forEach((button) => {
        button.addEventListener('click', () => closeQuiz(true));
      });

      root.querySelector('[data-ffq-start]')?.addEventListener('click', () => {
        track('FlightFuelQuizStart');
        showQuestion(0);
      });

      questions.forEach((question, index) => {
        question.querySelectorAll('[data-ffq-answer]').forEach((button) => {
          button.addEventListener('click', () => {
            question.querySelectorAll('[data-ffq-answer]').forEach((answer) => {
              answer.classList.remove('is-selected');
            });
            button.classList.add('is-selected');
            answers[index] = {
              category: question.dataset.category || 'none',
              score: Number(button.dataset.score || 0)
            };
            track('FlightFuelQuizStep');

            window.setTimeout(() => {
              const nextQuestion = index + 1;
              if (!checkpointSeen && nextQuestion === checkpointAfter) {
                currentQuestion = nextQuestion;
                showCheckpoint();
                return;
              }
              if (nextQuestion < questions.length) {
                showQuestion(nextQuestion);
                return;
              }
              showResult();
            }, 230);
          });
        });
      });

      root.querySelector('[data-ffq-continue]')?.addEventListener('click', () => {
        showQuestion(currentQuestion);
      });

      backButton.addEventListener('click', () => {
        if (!discount.hidden) {
          showRecommendation();
          return;
        }
        if (!recommendation.hidden) {
          showResult();
          return;
        }
        if (!result.hidden) {
          showQuestion(questions.length - 1);
          return;
        }
        if (!checkpoint.hidden) {
          showQuestion(Math.max(checkpointAfter - 1, 0));
          return;
        }
        if (currentQuestion > 0) {
          showQuestion(currentQuestion - 1);
          return;
        }
        showIntro();
      });

      root.querySelector('[data-ffq-see-recommendation]')?.addEventListener('click', () => {
        showRecommendation();
      });

      root.querySelector('[data-ffq-result-cta]')?.addEventListener('click', () => {
        showDiscount();
      });

      root.querySelector('[data-ffq-buy]')?.addEventListener('click', () => {
        closeAndScroll(root.dataset.scrollTarget || '#dartitis-buy', 'FlightFuelQuizBuyBoxClick');
      });

      root.querySelector('[data-ffq-secondary-cta]')?.addEventListener('click', () => {
        closeAndScroll(root.dataset.secondaryTarget || '#what-dartitis-feels-like', 'FlightFuelQuizLearnClick');
      });

      root.querySelector('[data-ffq-recommendation-back]')?.addEventListener('click', () => {
        showResult();
      });

      root.querySelector('[data-ffq-discount-back]')?.addEventListener('click', () => {
        showRecommendation();
      });

      root.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          closeQuiz(true);
          return;
        }
        if (event.key !== 'Tab') return;
        const focusable = Array.from(
          dialog.querySelectorAll('button:not([hidden]):not([disabled]), a[href], [tabindex]:not([tabindex="-1"])')
        ).filter((element) => element.offsetParent !== null);
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });

      if (resetMode) storage.remove();
      showIntro();

      if (shouldTrigger && (previewMode || storage.get() !== 'dismissed')) {
        window.setTimeout(openQuiz, Number(root.dataset.delay || 500));
      }
    };

    const initAllQuizzes = (scope = document) => {
      scope.querySelectorAll('[data-ffq]').forEach(initQuiz);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAllQuizzes());
    } else {
      initAllQuizzes();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initAllQuizzes(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flight-fuel-review-switcher"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-ffreviews-section]';

    const initializeReviewCarousel = (carousel, onHeightChange) => {
      if (!carousel || carousel.dataset.ffreviewsReady === 'true') return;
      carousel.dataset.ffreviewsReady = 'true';

      const viewport = carousel.querySelector('[data-ffreviews-viewport]');
      const track = carousel.querySelector('[data-ffreviews-track]');
      const slides = Array.from(carousel.querySelectorAll('[data-ffreviews-slide]'));
      const previous = carousel.querySelector('[data-ffreviews-prev]');
      const next = carousel.querySelector('[data-ffreviews-next]');
      const dots = carousel.querySelector('[data-ffreviews-dots]');
      const slideLabel = carousel.dataset.slideLabel || 'Go to review';

      if (!viewport || !track || !slides.length || !previous || !next || !dots) return;

      let activeIndex = 0;
      let positions = [];
      let startX = 0;
      let dragging = false;

      const calculatePositions = () => {
        const maximumOffset = Math.max(0, track.scrollWidth - viewport.clientWidth);
        const nextPositions = [];

        slides.forEach((slide, slideIndex) => {
          const offset = Math.min(slide.offsetLeft, maximumOffset);
          const duplicate = nextPositions.some((position) => Math.abs(position.offset - offset) < 2);

          if (!duplicate) {
            nextPositions.push({ slideIndex, offset });
          }
        });

        return nextPositions.length ? nextPositions : [{ slideIndex: 0, offset: 0 }];
      };

      const positionTrack = (instant = false) => {
        const activePosition = positions[activeIndex];
        if (!activePosition) return;

        if (instant) track.style.transition = 'none';
        track.style.transform = `translate3d(${-activePosition.offset}px, 0, 0)`;

        if (instant) {
          requestAnimationFrame(() => {
            track.style.transition = '';
          });
        }
      };

      const update = (index, instant = false) => {
        if (!positions.length) return;
        activeIndex = (index + positions.length) % positions.length;
        const activePosition = positions[activeIndex];
        const viewportStart = activePosition.offset;
        const viewportEnd = viewportStart + viewport.clientWidth;

        slides.forEach((slide, slideIndex) => {
          const active = slideIndex === activePosition.slideIndex;
          const slideStart = slide.offsetLeft;
          const slideEnd = slideStart + slide.offsetWidth;
          const visible = slideEnd > viewportStart + 1 && slideStart < viewportEnd - 1;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', visible ? 'false' : 'true');
        });

        Array.from(dots.children).forEach((dot, dotIndex) => {
          const active = dotIndex === activeIndex;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });

        positionTrack(instant);
      };

      const renderDots = () => {
        dots.replaceChildren();

        positions.forEach((position, index) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = `ffreviews__dot${index === activeIndex ? ' is-active' : ''}`;
          dot.setAttribute('aria-label', `${slideLabel} ${index + 1}`);
          dot.setAttribute('aria-current', index === activeIndex ? 'true' : 'false');
          dot.addEventListener('click', () => update(index));
          dots.appendChild(dot);
        });
      };

      const rebuildPositions = () => {
        const activeSlideIndex = positions[activeIndex]?.slideIndex || 0;
        positions = calculatePositions();
        activeIndex = positions.reduce((nearestIndex, position, index) => {
          const nearestDistance = Math.abs(positions[nearestIndex].slideIndex - activeSlideIndex);
          const currentDistance = Math.abs(position.slideIndex - activeSlideIndex);
          return currentDistance < nearestDistance ? index : nearestIndex;
        }, 0);
        renderDots();
      };

      previous.addEventListener('click', () => update(activeIndex - 1));
      next.addEventListener('click', () => update(activeIndex + 1));

      viewport.addEventListener('pointerdown', (event) => {
        dragging = true;
        startX = event.clientX;
        viewport.classList.add('is-dragging');
        viewport.setPointerCapture(event.pointerId);
      });

      viewport.addEventListener('pointerup', (event) => {
        if (!dragging) return;
        dragging = false;
        viewport.classList.remove('is-dragging');
        const distance = event.clientX - startX;
        if (Math.abs(distance) > 44) {
          update(activeIndex + (distance < 0 ? 1 : -1));
        }
      });

      viewport.addEventListener('pointercancel', () => {
        dragging = false;
        viewport.classList.remove('is-dragging');
      });

      const resize = () => {
        rebuildPositions();
        update(activeIndex, true);
        if (onHeightChange) onHeightChange();
      };

      if ('ResizeObserver' in window) {
        const resizeObserver = new ResizeObserver(resize);
        resizeObserver.observe(viewport);
      } else {
        window.addEventListener('resize', resize);
      }

      carousel.querySelectorAll('img').forEach((image) => {
        if (!image.complete) image.addEventListener('load', resize, { once: true });
      });

      rebuildPositions();
      update(0, true);
    };

    const initializeSection = (section) => {
      if (!section || section.dataset.ffreviewsSectionReady === 'true') return;
      section.dataset.ffreviewsSectionReady = 'true';

      const stage = section.querySelector('[data-ffreviews-stage]');
      const buttons = Array.from(section.querySelectorAll('[data-ffreviews-view]'));
      const panels = Array.from(section.querySelectorAll('[data-ffreviews-panel]'));
      let currentView = 'reviews';

      const syncHeight = () => {
        if (!stage) return;
        const activePanel = panels.find((panel) => panel.dataset.ffreviewsPanel === currentView);
        if (activePanel) stage.style.height = `${activePanel.scrollHeight}px`;
      };

      initializeReviewCarousel(section.querySelector('[data-ffreviews-carousel]'), syncHeight);

      const setView = (view) => {
        currentView = view;
        const showPros = view === 'pros';
        section.classList.toggle('is-pro-view', showPros);

        buttons.forEach((button) => {
          const active = button.dataset.ffreviewsView === view;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-selected', active ? 'true' : 'false');
          button.tabIndex = active ? 0 : -1;
        });

        panels.forEach((panel) => {
          const active = panel.dataset.ffreviewsPanel === view;
          panel.setAttribute('aria-hidden', active ? 'false' : 'true');
          panel.toggleAttribute('inert', !active);
        });

        requestAnimationFrame(syncHeight);
        window.setTimeout(syncHeight, 840);
      };

      buttons.forEach((button) => {
        button.addEventListener('click', () => setView(button.dataset.ffreviewsView));
        button.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          const nextView = button.dataset.ffreviewsView === 'reviews' ? 'pros' : 'reviews';
          const nextButton = buttons.find((item) => item.dataset.ffreviewsView === nextView);
          setView(nextView);
          if (nextButton) nextButton.focus();
        });
      });

      section.querySelectorAll('img').forEach((image) => {
        if (!image.complete) image.addEventListener('load', syncHeight, { once: true });
      });

      if ('ResizeObserver' in window) {
        const panelObserver = new ResizeObserver(syncHeight);
        panels.forEach((panel) => panelObserver.observe(panel));
      } else {
        window.addEventListener('resize', syncHeight);
      }

      requestAnimationFrame(syncHeight);

      if (!('IntersectionObserver' in window)) {
        section.classList.add('is-visible');
      } else {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              section.classList.add('is-visible');
              observer.disconnect();
            });
          },
          { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
        );
        observer.observe(section);
      }
    };

    document.querySelectorAll(selector).forEach(initializeSection);

    document.addEventListener('shopify:section:load', (event) => {
      if (event.target.matches(selector)) {
        initializeSection(event.target);
      } else {
        event.target.querySelectorAll(selector).forEach(initializeSection);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
